module.exports = __webpack_public_path__ + "media/images/athletes/3589-0862c852372ed855c5dff3408f490c11.png";